(() => {
  'use strict';

  const root = document.querySelector('.gut-check');
  if (!root) return;

  const PRODUCT_URL = 'https://guttiful.com/products/guttiful-gut-health-supplement?utm_source=quiz&utm_medium=funnel';

  /* -----------------------------------------------------------------
     Question data — one source of truth for the dynamic question
     screen. type: 'single' | 'multi' | 'chip'.
  ----------------------------------------------------------------- */
  const QUESTIONS = [
    {
      id: 'q1',
      type: 'multi',
      heading: "What bothers you the most?",
      hint: 'SELECT ALL THAT APPLY',
      options: [
        { value: 'bloating', icon: '🎈', label: 'Bloating', sub: 'My stomach puffs up' },
        { value: 'gas', icon: '💨', label: 'Gas' },
        { value: 'heavy', icon: '🧱', label: 'Heavy feeling after meals' },
        { value: 'irregularity', icon: '⏳', label: 'Irregularity', sub: 'Not going regularly' },
        { value: 'lowenergy', icon: '🥱', label: 'Low energy after eating' },
        { value: 'indigestion', icon: '🔥', label: 'Occasional indigestion' },
      ],
    },
    {
      id: 'q2',
      type: 'multi',
      heading: 'When do you usually feel it?',
      hint: 'SELECT ALL THAT APPLY',
      options: [
        { value: 'aftermeals', icon: '🍽️', label: 'Right after meals' },
        { value: 'evening', icon: '🌙', label: 'In the evening' },
        { value: 'morning', icon: '☀️', label: 'First thing in the morning' },
        { value: 'afterfoods', icon: '🥖', label: 'After certain foods' },
        { value: 'random', icon: '🎲', label: "It's random" },
      ],
    },
    {
      id: 'q3',
      type: 'single',
      heading: 'How often does this happen?',
      hint: 'CHOOSE ONE',
      options: [
        { value: 'daily', icon: '📅', label: 'Almost every day' },
        { value: 'few', icon: '🗓️', label: 'A few times a week' },
        { value: 'weekly', icon: '📆', label: 'About once a week' },
        { value: 'rarely', icon: '🌤️', label: 'Rarely' },
      ],
    },
    {
      id: 'q4',
      type: 'multi',
      heading: 'Which foods seem to set it off?',
      hint: 'SELECT ALL THAT APPLY',
      options: [
        { value: 'dairy', icon: '🥛', label: 'Dairy' },
        { value: 'breadpasta', icon: '🍝', label: 'Bread & pasta' },
        { value: 'fried', icon: '🍟', label: 'Fried or fatty food' },
        { value: 'coffee', icon: '☕', label: 'Coffee or alcohol' },
        { value: 'bigportions', icon: '🍔', label: 'Big portions' },
        { value: 'notsure', icon: '🤷', label: 'Not sure', exclusive: true },
      ],
    },
    {
      id: 'q5',
      type: 'single',
      heading: 'How regular are your bathroom visits?',
      hint: 'CHOOSE ONE',
      options: [
        { value: 'dailyplus', icon: '✅', label: 'Once a day or more' },
        { value: 'lessdaily', icon: '🐢', label: 'Less than once a day' },
        { value: 'allover', icon: '🔀', label: 'All over the place' },
      ],
    },
    {
      id: 'q6',
      type: 'multi',
      heading: 'What have you already tried?',
      hint: 'SELECT ALL THAT APPLY',
      options: [
        { value: 'acv', icon: '🍎', label: 'ACV gummies or shots' },
        { value: 'probiotics', icon: '🦠', label: 'Probiotics' },
        { value: 'fiber', icon: '🌾', label: 'Fiber supplements' },
        { value: 'enzymes', icon: '🧪', label: 'Digestive enzymes' },
        { value: 'other', icon: '💊', label: 'Other supplements', sub: 'Like magnesium, aloe or herbal teas' },
        { value: 'cutting', icon: '🚫', label: 'Cutting out foods' },
        { value: 'nothing', icon: '🆕', label: 'Nothing yet', exclusive: true },
      ],
    },
    {
      id: 'q7',
      type: 'single',
      heading: 'Did it help?',
      hint: 'CHOOSE ONE',
      skipIf: (answers) => (answers.q6 || []).includes('nothing'),
      options: [
        { value: 'lot', icon: '😀', label: 'Yes, a lot' },
        { value: 'little', icon: '🙂', label: 'A little' },
        { value: 'notreally', icon: '😕', label: 'Not really' },
        { value: 'toomany', icon: '🔁', label: 'It helped, but I had to take too many things' },
      ],
    },
    {
      id: 'q8',
      type: 'multi',
      heading: 'What matters most to you in a supplement?',
      hint: 'SELECT ALL THAT APPLY',
      options: [
        { value: 'amounts', icon: '🔍', label: 'Seeing exact ingredient amounts' },
        { value: 'routine', icon: '1️⃣', label: 'One simple daily routine' },
        { value: 'vegan', icon: '🌱', label: 'Vegan & non-GMO' },
        { value: 'guarantee', icon: '🛡️', label: 'A money-back guarantee' },
        { value: 'value', icon: '💲', label: 'Good value' },
      ],
    },
    {
      id: 'q9',
      type: 'chip',
      heading: "What's your age?",
      options: [
        { value: '18-29', label: '18–29' },
        { value: '30-39', label: '30–39' },
        { value: '40-49', label: '40–49' },
        { value: '50-59', label: '50–59' },
        { value: '60+', label: '60+' },
      ],
    },
    {
      id: 'q10',
      type: 'single',
      heading: 'What would feel like a win in 60 days?',
      hint: 'CHOOSE ONE',
      options: [
        { value: 'lighter', icon: '🪶', label: 'Feeling lighter after meals' },
        { value: 'lessbloating', icon: '🎈', label: 'Less bloating' },
        { value: 'regular', icon: '🗓️', label: 'A more regular routine' },
        { value: 'energy', icon: '⚡', label: 'More energy through the day' },
      ],
    },
  ];

  /* -----------------------------------------------------------------
     Flow: fixed 10-slot step list for progress/counter purposes — just
     the 10 real questions above. Gender is answered on the intro screen
     itself (not shown as a counted "question"), so it's intentionally
     left out of this list; it used to occupy slot 0 here, which was why
     the counter read "X of 11" instead of "X of 10".
     Screens 'info', 'loading', 'email', 'results' sit between/after
     and are not counted.
  ----------------------------------------------------------------- */
  const STEP_ORDER = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10'];
  const TOTAL_STEPS = STEP_ORDER.length;

  const state = {
    answers: {
      gender: null,
      q1: [], q2: [], q3: null, q4: [], q5: null, q6: [], q7: null, q8: [], q9: null, q10: null,
    },
    screen: 'intro', // intro | question | info | loading | email | results
    stepIndex: 0, // index into STEP_ORDER, only meaningful while screen === 'question' (or gender on intro)
    history: ['intro'],
  };

  /* -----------------------------------------------------------------
     Tracking — fires Meta Pixel + GA4 events if present on the page.
     Falls through silently if neither is installed.
  ----------------------------------------------------------------- */
  function track(eventName, standardMetaEvent, params) {
    params = params || {};
    try {
      if (window.fbq) {
        if (standardMetaEvent) {
          window.fbq('track', standardMetaEvent, params);
        } else {
          window.fbq('trackCustom', eventName, params);
        }
      }
    } catch (e) {
      /* tracking must never break the quiz */
    }
    try {
      if (window.gtag) {
        window.gtag('event', eventName, params);
      }
    } catch (e) {
      /* no-op */
    }
  }

  /* -----------------------------------------------------------------
     Lead submission — creates/updates a real Shopify customer via the
     same native "customer" form the footer newsletter signup uses (see
     sections/footer.liquid), tagged "gut-check-quiz" so these leads are
     identifiable/segmentable in Admin > Customers.

     This used to be a hand-built hidden <form> submitted to a hidden
     iframe, so the quiz UI never had to reload. That silently failed in
     production: Shopify's hCaptcha spam protection only attaches a token
     to a form when a real person actually interacts with that exact
     <input> (focuses/types into it) before submit — see
     https://shopify.dev/docs/storefronts/themes/trust-security/captcha.
     A hidden, JS-filled, programmatically-submitted form is never
     interacted with, so no token was ever attached and Shopify rejected
     every submission with 400 "Missing CAPTCHA token" — confirmed
     directly against the live store, including from a real browser.

     The fix is to make the actual visible #gc-email-input the real
     Shopify customer form (rendered via the {% form %} Liquid tag in
     gut-check-quiz.liquid, same mechanism as the footer), so the normal
     user interaction that generates a valid hCaptcha token actually
     happens. That means a real top-level submission/redirect instead of
     a backgrounded one — handled by return_to: 'back' on the form tag
     plus restorePendingResults() below, which stashes the answers before
     navigating away and jumps straight back to the results screen once
     Shopify redirects back here.

     Quiz answers themselves aren't stored on the customer by this —
     Shopify's native customer form only accepts email/name/tags, not
     arbitrary data. Storing the actual answers (not just the email)
     would need customer metafields, which requires a small backend proxy
     since the Admin API can't be called directly from the browser.
  ----------------------------------------------------------------- */
  const RESULTS_RESTORE_KEY = 'gc_quiz_pending_results';

  function restorePendingResults() {
    let saved = null;
    try {
      saved = sessionStorage.getItem(RESULTS_RESTORE_KEY);
      sessionStorage.removeItem(RESULTS_RESTORE_KEY);
    } catch (e) {
      return false;
    }
    if (!saved) return false;
    try {
      state.answers = JSON.parse(saved);
      return true;
    } catch (e) {
      return false;
    }
  }

  /* -----------------------------------------------------------------
     DOM refs
  ----------------------------------------------------------------- */
  const els = {
    back: root.querySelector('.gc-back'),
    stepCounter: root.querySelector('.gc-step-counter'),
    progressFill: root.querySelector('.gc-progress-fill'),
    main: root.querySelector('.gc-main'),
    bottombar: root.querySelector('.gc-bottombar'),
    bottombarInner: root.querySelector('.gc-bottombar__inner'),
    screens: {
      intro: root.querySelector('[data-screen="intro"]'),
      question: root.querySelector('[data-screen="question"]'),
      info: root.querySelector('[data-screen="info"]'),
      loading: root.querySelector('[data-screen="loading"]'),
      email: root.querySelector('[data-screen="email"]'),
      results: root.querySelector('[data-screen="results"]'),
    },
  };

  /* -----------------------------------------------------------------
     Progress + header
  ----------------------------------------------------------------- */
  function setProgress(pct) {
    els.progressFill.style.width = pct + '%';
  }

  function progressForStepIndex(idx) {
    // idx = number of counted steps completed so far (0..11)
    return (idx / TOTAL_STEPS) * 96;
  }

  function updateHeader() {
    const onIntro = state.screen === 'intro';
    const onLoading = state.screen === 'loading';
    const onResults = state.screen === 'results';
    els.back.classList.toggle('is-visible', !onIntro && !onLoading && !onResults);

    const onQuestion = state.screen === 'question';
    els.stepCounter.classList.toggle('is-visible', onQuestion);
    if (onQuestion) {
      els.stepCounter.textContent = (state.stepIndex + 1) + ' of ' + TOTAL_STEPS;
    }
  }

  /* -----------------------------------------------------------------
     Screen switching
  ----------------------------------------------------------------- */
  function showScreen(name) {
    Object.keys(els.screens).forEach((key) => {
      els.screens[key].classList.toggle('is-active', key === name);
    });
    state.screen = name;
    root.setAttribute('data-screen', name);
    updateHeader();
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  function showBottomBar(html) {
    if (!html) {
      els.bottombar.classList.remove('is-visible');
      els.bottombarInner.innerHTML = '';
      return;
    }
    els.bottombarInner.innerHTML = html;
    els.bottombar.classList.add('is-visible');
  }

  /* -----------------------------------------------------------------
     Navigation helpers
  ----------------------------------------------------------------- */
  function nextStepIndexSkippingAsNeeded(fromIdx) {
    let idx = fromIdx + 1;
    while (idx < STEP_ORDER.length) {
      const id = STEP_ORDER[idx];
      const q = QUESTIONS.find((item) => item.id === id);
      if (q && typeof q.skipIf === 'function' && q.skipIf(state.answers)) {
        idx++;
        continue;
      }
      break;
    }
    return idx;
  }

  function goToStepIndex(idx) {
    if (idx >= STEP_ORDER.length) {
      renderInfoOrNext();
      return;
    }
    state.stepIndex = idx;
    const id = STEP_ORDER[idx];
    renderQuestion(id);
    showScreen('question');
    setProgress(progressForStepIndex(idx + 1));
    state.history.push('question:' + id);
    track('QuizStep', null, { step: id });
  }

  function renderInfoOrNext() {
    // After q7 (or its skip) comes the info screen, then q8.. resume.
    renderInfoScreen();
    showScreen('info');
    state.history.push('info');
  }

  function goBack() {
    state.history.pop(); // current screen
    // 'loading' auto-advances on its own and has no meaningful "back"
    // destination of its own — skip past it to whatever came before it.
    while (state.history[state.history.length - 1] === 'loading') {
      state.history.pop();
    }
    const prev = state.history[state.history.length - 1];
    if (!prev || prev === 'intro') {
      showScreen('intro');
      setProgress(0);
      showBottomBar(null);
      state.history = ['intro'];
      return;
    }
    if (prev === 'info') {
      renderInfoScreen();
      showScreen('info');
      return;
    }
    if (prev.startsWith('question:')) {
      const id = prev.split(':')[1];
      const idx = STEP_ORDER.indexOf(id);
      state.stepIndex = idx;
      renderQuestion(id);
      showScreen('question');
      setProgress(progressForStepIndex(idx + 1));
    }
  }

  /* -----------------------------------------------------------------
     Intro screen
  ----------------------------------------------------------------- */
  function initIntro() {
    const buttons = els.screens.intro.querySelectorAll('[data-gender]');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        state.answers.gender = btn.getAttribute('data-gender');
        track('QuizStep', null, { step: 'gender', answer: state.answers.gender });
        state.history = ['intro'];
        goToStepIndex(0); // first real question (q1)
      });
    });
  }

  /* -----------------------------------------------------------------
     Question screen rendering
  ----------------------------------------------------------------- */
  function renderQuestion(id) {
    const q = QUESTIONS.find((item) => item.id === id);
    const container = els.screens.question;
    const current = state.answers[id];

    const isChip = q.type === 'chip';
    const isMulti = q.type === 'multi';

    const optionsHtml = q.options.map((opt) => {
      const selected = isMulti
        ? (current || []).includes(opt.value)
        : current === opt.value;
      const checkShape = isMulti ? 'square' : 'circle';
      const classes = ['gc-option'];
      if (isChip) classes.push('gc-option--chip');

      const iconHtml = isChip ? '' :
        '<span class="gc-option__icon" aria-hidden="true">' + opt.icon + '</span>';
      const subHtml = opt.sub ? '<span class="gc-option__sub">' + opt.sub + '</span>' : '';
      const checkHtml = isChip ? '' :
        '<span class="gc-option__check gc-option__check--' + checkShape + '" aria-hidden="true">✓</span>';

      return '<button type="button" class="' + classes.join(' ') + '" data-value="' + opt.value +
        '" data-exclusive="' + (opt.exclusive ? '1' : '0') +
        '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
        iconHtml +
        '<span class="gc-option__label">' + opt.label + subHtml + '</span>' +
        checkHtml +
        '</button>';
    }).join('');

    const hintHtml = q.hint ? '<p class="gc-hint">' + q.hint + '</p>' : '';

    container.innerHTML =
      '<div class="gc-question">' +
      hintHtml +
      '<h2>' + q.heading + '</h2>' +
      '<div class="gc-options' + (isChip ? ' gc-options--chips' : '') + '">' + optionsHtml + '</div>' +
      '</div>';

    const optionButtons = container.querySelectorAll('.gc-option');

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        handleOptionClick(q, btn, optionButtons);
      });
    });

    if (isMulti) {
      showBottomBar(
        '<button type="button" class="gc-btn gc-btn--primary" id="gc-next-btn" disabled>Next</button>'
      );
      const nextBtn = document.getElementById('gc-next-btn');
      nextBtn.onclick = () => goNextFrom(q.id);
      updateMultiNextButton(current);
    } else {
      showBottomBar(null);
    }
  }

  function updateMultiNextButton(currentValues) {
    const btn = document.getElementById('gc-next-btn');
    if (!btn) return;
    btn.disabled = !(currentValues && currentValues.length > 0);
  }

  function handleOptionClick(q, btn, allButtons) {
    const value = btn.getAttribute('data-value');
    const exclusive = btn.getAttribute('data-exclusive') === '1';

    if (q.type === 'single' || q.type === 'chip') {
      allButtons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      state.answers[q.id] = value;
      track('QuizStep', null, { step: q.id, answer: value });
      setTimeout(() => {
        goNextFrom(q.id);
      }, 280);
      return;
    }

    // multi-choice
    let current = state.answers[q.id] || [];
    const alreadySelected = current.includes(value);

    if (exclusive) {
      current = alreadySelected ? [] : [value];
    } else {
      if (alreadySelected) {
        current = current.filter((v) => v !== value);
      } else {
        current = current.filter((v) => {
          const opt = q.options.find((o) => o.value === v);
          return !(opt && opt.exclusive);
        });
        current.push(value);
      }
    }

    state.answers[q.id] = current;

    allButtons.forEach((b) => {
      const v = b.getAttribute('data-value');
      b.setAttribute('aria-pressed', current.includes(v) ? 'true' : 'false');
    });

    updateMultiNextButton(current);
  }

  /* -----------------------------------------------------------------
     Single place that decides what comes after a given question —
     used by both the auto-advance (single/chip) and the Next button
     (multi) paths, so the routing logic only exists once.
  ----------------------------------------------------------------- */
  function goNextFrom(questionId) {
    if (questionId === 'q6') {
      const q7 = QUESTIONS.find((q) => q.id === 'q7');
      if (q7.skipIf(state.answers)) {
        renderInfoOrNext();
      } else {
        goToStepIndex(STEP_ORDER.indexOf('q7'));
      }
      return;
    }
    if (questionId === 'q7') {
      renderInfoOrNext();
      return;
    }
    if (questionId === 'q10') {
      goToLoading();
      return;
    }
    goToStepIndex(nextStepIndexSkippingAsNeeded(state.stepIndex));
  }

  /* -----------------------------------------------------------------
     Info screen
  ----------------------------------------------------------------- */
  function renderInfoScreen() {
    const triedValues = (state.answers.q6 || []).filter((v) => v !== 'nothing' && v !== 'cutting');
    const container = els.screens.info;
    let headingHtml;
    if (triedValues.length >= 2) {
      headingHtml = "You're not alone. You've tried " + triedValues.length +
        ' different things. Guttiful puts the main ones in one capsule.';
    } else {
      headingHtml = "You're not alone. Most gut products cover one piece of the puzzle. Guttiful covers four.";
    }

    container.innerHTML =
      '<h2>' + headingHtml + '</h2>' +
      '<p class="gc-info__text">Every dose is on the label. No proprietary blends.</p>' +
      '<div class="gc-ingredient-grid">' +
        ingredientCard('1000mg', 'Organic apple cider vinegar') +
        ingredientCard('200mg', 'Inulin prebiotic fiber') +
        ingredientCard('100mg', 'DigeZyme® enzymes') +
        ingredientCard('1B CFU', 'L. acidophilus LA85 probiotic') +
      '</div>' +
      '<div class="gc-compare">' +
        '<table>' +
          '<thead><tr><th>In one capsule</th><th>Guttiful</th><th>Typical</th></tr></thead>' +
          '<tbody>' +
            compareRow('Apple cider vinegar', true, false) +
            compareRow('Prebiotic fiber', true, false) +
            compareRow('Digestive enzymes', true, false) +
            compareRow('Live probiotic', true, true) +
            compareRow('Doses listed', true, false, 'Often hidden') +
          '</tbody>' +
        '</table>' +
      '</div>';

    showBottomBar('<button type="button" class="gc-btn gc-btn--primary" id="gc-info-continue">Continue to my results</button>');
    document.getElementById('gc-info-continue').addEventListener('click', () => {
      goToStepIndex(STEP_ORDER.indexOf('q8'));
    });
  }

  function ingredientCard(num, label) {
    return '<div class="gc-ingredient-card"><div class="gc-ingredient-card__num">' + num +
      '</div><div class="gc-ingredient-card__label">' + label + '</div></div>';
  }

  function compareRow(label, guttiful, typical, typicalText) {
    const guttifulCell = guttiful
      ? '<span class="gc-compare__yes">✓</span>'
      : '<span class="gc-compare__no">–</span>';
    let typicalCell;
    if (typicalText) {
      typicalCell = '<span class="gc-compare__no">' + typicalText + '</span>';
    } else {
      typicalCell = typical
        ? '<span class="gc-compare__yes">✓</span>'
        : '<span class="gc-compare__no">–</span>';
    }
    return '<tr><th scope="row">' + label + '</th><td>' + guttifulCell + '</td><td>' + typicalCell + '</td></tr>';
  }

  /* -----------------------------------------------------------------
     Loading screen
  ----------------------------------------------------------------- */
  function goToLoading() {
    showScreen('loading');
    setProgress(96);
    state.history.push('loading');
    showBottomBar(null);
    runLoadingAnimation();
  }

  function runLoadingAnimation() {
    const rows = els.screens.loading.querySelectorAll('.gc-loading-row__fill');
    const pcts = els.screens.loading.querySelectorAll('.gc-loading-row__pct');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      rows.forEach((row, i) => {
        row.style.transform = 'scaleX(1)';
        if (pcts[i]) pcts[i].textContent = '100%';
      });
      setTimeout(finishLoading, 300);
      return;
    }

    let rowIndex = 0;
    function animateRow() {
      if (rowIndex >= rows.length) {
        setTimeout(finishLoading, 400);
        return;
      }
      const row = rows[rowIndex];
      const pct = pcts[rowIndex];
      let value = 0;
      const duration = 1500;
      const start = performance.now();
      function step(now) {
        const elapsed = now - start;
        value = Math.min(100, Math.round((elapsed / duration) * 100));
        row.style.transform = 'scaleX(' + (value / 100) + ')';
        // Force the browser to commit the style change now rather than
        // batching it — some mobile in-app browsers (Messenger/Instagram
        // webviews) were observed coalescing rapid transform writes and
        // never painting any intermediate frame, leaving the bar visually
        // stuck at 0% while the text counter kept advancing normally.
        void row.offsetHeight;
        if (pct) pct.textContent = value + '%';
        if (value < 100) {
          requestAnimationFrame(step);
        } else {
          row.style.transform = 'scaleX(1)';
          rowIndex++;
          animateRow();
        }
      }
      requestAnimationFrame(step);
    }
    animateRow();
  }

  function finishLoading() {
    showScreen('email');
    setProgress(98);
    state.history.push('email');
    showBottomBar(
      '<button type="submit" form="gc-email-form" id="gc-email-submit" class="gc-btn gc-btn--amber">Unlock my results</button>'
    );
    initEmailScreenIfNeeded();
  }

  /* -----------------------------------------------------------------
     Email screen
  ----------------------------------------------------------------- */
  let emailScreenInitialized = false;
  function initEmailScreenIfNeeded() {
    if (emailScreenInitialized) return;
    emailScreenInitialized = true;

    const form = els.screens.email.querySelector('#gc-email-form');
    const input = els.screens.email.querySelector('#gc-email-input');
    const errorEl = els.screens.email.querySelector('.gc-field-error');

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    form.addEventListener('submit', (e) => {
      const value = input.value.trim();
      if (!isValidEmail(value)) {
        e.preventDefault();
        errorEl.classList.add('is-visible');
        input.setAttribute('aria-invalid', 'true');
        return;
      }
      errorEl.classList.remove('is-visible');
      input.removeAttribute('aria-invalid');

      // Valid — let this real submit proceed (no preventDefault). The
      // browser navigates to /contact for real, which is what lets
      // Shopify's hCaptcha see a genuine interaction and attach a token;
      // Shopify then redirects back here per return_to: 'back'. Stash the
      // answers first so restorePendingResults() can jump straight to the
      // results screen once this page reloads.
      try {
        sessionStorage.setItem(RESULTS_RESTORE_KEY, JSON.stringify(state.answers));
      } catch (err) {
        /* ignore */
      }
      track('Lead', 'Lead', { content_name: 'gut-check-quiz' });
    });
  }

  /* -----------------------------------------------------------------
     Results screen
  ----------------------------------------------------------------- */
  function computeProfile() {
    const a = state.answers;
    const triedCount = (a.q6 || []).filter((v) => v !== 'nothing' && v !== 'cutting').length;

    if (triedCount >= 2 || a.q7 === 'toomany') {
      return {
        name: 'The Supplement Juggler',
        text: "You've been piecing your routine together from several products. A single daily capsule that covers ACV, fiber, enzymes and a probiotic can make it simpler.",
        dagger: false,
      };
    }
    if ((a.q1 || []).includes('irregularity') || a.q5 !== 'dailyplus') {
      return {
        name: 'The Off-Rhythm Gut',
        text: "Your routine isn't as regular as you'd like. Prebiotic fiber and a live probiotic support regularity as part of a daily habit.",
        dagger: true,
      };
    }
    if ((a.q2 || []).includes('aftermeals') || (a.q1 || []).includes('heavy')) {
      return {
        name: 'The After-Meal Bloater',
        text: 'Your discomfort shows up around food. Digestive enzymes help break down proteins, fats and carbs, and ACV supports digestion.',
        dagger: true,
      };
    }
    return {
      name: 'The Unsettled Gut',
      text: 'Your symptoms come and go. A steady daily routine that supports your gut microbiome is a good place to start.',
      dagger: true,
    };
  }

  function labelsFor(questionId, values) {
    const q = QUESTIONS.find((item) => item.id === questionId);
    if (!q) return '';
    const list = Array.isArray(values) ? values : [values];
    return list
      .map((v) => {
        const opt = q.options.find((o) => o.value === v);
        return opt ? opt.label : v;
      })
      .filter(Boolean)
      .join(', ');
  }

  function goToResults() {
    const profile = computeProfile();
    const container = els.screens.results;

    container.innerHTML =
      '<div class="gc-profile-card">' +
        '<span class="gc-profile-card__label">YOUR GUT PROFILE</span>' +
        '<h1>' + profile.name + '</h1>' +
        '<p>' + profile.text + '</p>' +
      '</div>' +
      '<div class="gc-summary-card">' +
        summaryRow('Main issue', labelsFor('q1', state.answers.q1)) +
        summaryRow('When', labelsFor('q2', state.answers.q2)) +
        summaryRow('How often', labelsFor('q3', state.answers.q3)) +
        summaryRow('Your 60-day goal', labelsFor('q10', state.answers.q10)) +
      '</div>' +
      '<div class="gc-plan">' +
        '<h2>Your 60-day plan</h2>' +
        planRow(1, 'Take 2 Guttiful capsules daily, with a meal.') +
        planRow(2, 'Note how you feel after meals each week.') +
        planRow(3, "Not feeling the difference? You're covered by our 30-day guarantee.") +
      '</div>' +
      '<div class="gc-offer">' +
        '<span class="gc-offer__tag">QUIZ OFFER</span>' +
        '<h2>Start your risk-free trial</h2>' +
        '<ul class="gc-offer-list">' +
          '<li>Subscribe &amp; save 15%</li>' +
          '<li>Free shipping on bundles</li>' +
          '<li>30-day money-back guarantee</li>' +
          '<li>Cancel anytime</li>' +
        '</ul>' +
        '<a href="' + PRODUCT_URL + '" class="gc-btn gc-btn--primary" id="gc-cta">Get my Guttiful →</a>' +
      '</div>' +
      '<p class="gc-disclaimer">†These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. Individual results vary.</p>' +
      '<button type="button" class="gc-btn gc-btn--ghost gc-restart" id="gc-restart">Restart quiz</button>';

    document.getElementById('gc-cta').addEventListener('click', () => {
      track('InitiateCheckout', 'InitiateCheckout', { content_name: 'gut-check-quiz', profile: profile.name });
    });
    document.getElementById('gc-restart').addEventListener('click', restartQuiz);

    showScreen('results');
    setProgress(100);
    showBottomBar(null);
    state.history.push('results');
    track('QuizComplete', null, { profile: profile.name });
  }

  function summaryRow(label, value) {
    return '<div class="gc-summary-row"><span class="gc-summary-row__label">' + label +
      '</span><span class="gc-summary-row__value">' + (value || '—') + '</span></div>';
  }

  function planRow(num, text) {
    return '<div class="gc-plan-row"><span class="gc-plan-row__num">' + num +
      '</span><span class="gc-plan-row__text">' + text + '</span></div>';
  }

  function restartQuiz() {
    state.answers = {
      gender: null, q1: [], q2: [], q3: null, q4: [], q5: null, q6: [], q7: null, q8: [], q9: null, q10: null,
    };
    state.history = ['intro'];
    showScreen('intro');
    setProgress(0);
  }

  /* -----------------------------------------------------------------
     Back button
  ----------------------------------------------------------------- */
  els.back.addEventListener('click', goBack);

  /* -----------------------------------------------------------------
     Supplement-facts label modal (intro screen)
  ----------------------------------------------------------------- */
  (() => {
    const openBtn = document.getElementById('gc-show-label');
    const modal = document.getElementById('gc-label-modal');
    if (!openBtn || !modal) return;
    const closeBtn = document.getElementById('gc-label-modal-close');
    const backdrop = document.getElementById('gc-label-modal-backdrop');

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKeydown);
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      openBtn.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
  })();

  /* -----------------------------------------------------------------
     Init
  ----------------------------------------------------------------- */
  initIntro();
  if (restorePendingResults()) {
    goToResults();
  } else {
    showScreen('intro');
    setProgress(0);
    track('QuizStart', null, { stage: 'page_view' });
  }
})();
